module.exports = __webpack_public_path__ + "static/media/gi.c607b46a.svg";